import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AgeGroupVariationFormData } from "../schemas/ageGroupVariationSchema";

// This component is being retired as colorScheme fields are no longer used
// Keep the file for now to avoid breaking references but it should not be rendered

interface ProgramColorFieldProps {
  form: UseFormReturn<AgeGroupVariationFormData>;
}

export const ProgramColorField: React.FC<ProgramColorFieldProps> = ({ form }) => {
  // This component is being retired and should not be used
  console.warn("ProgramColorField is deprecated and should not be used");
  return null;
};
